import dayjs from "dayjs";
import { useRef, useState } from "react";
import useFetch from "../_fetch";
import { message, Modal, theme } from "antd";

import { DatePicker } from "antd";
import { useCreateFinancialYear } from "../utils/queryUtils";
import { useDispatch, useSelector } from "react-redux";
import { setReloadFinancialYear } from "../store/action/reload";

export default function DropDown({ client_id, returnSelected = () => { }, canSubmit = true, years }) {
  const [modal1Open, setModal1Open] = useState(false);
  const [, setLoading] = useState(false);
  const { token: { colorPrimary } } = theme.useToken();
  const [selected, setSelected] = useState("");
  let dateRef = useRef();
  const { company } = useSelector(st => st.selected)
  const { mutateAsync: createFinancialYear } = useCreateFinancialYear()
  const dispatch = useDispatch();

  async function submit(e) {
    try {

      let end = `${dayjs(selected).format("YYYY")}`
      let start = `${dayjs(selected).subtract(1, 'year').format("YYYY")}`;

      setLoading(true);
      let body = {};
      body = {
        client_id: client_id,
        end: end,
        start: start,
        company: company
        // company: all.company._id
      };
      const data = await createFinancialYear(body)
      if (data) {
        dispatch(setReloadFinancialYear(true));
        message.success("Fy is created")
      }
      else {
        message.error("Something went wrong")
      }
      setModal1Open(false);
    }
    catch (err) {
      console.error(err)
    }
  }

  const openModel = (e) => {
    setSelected(e);
    if (canSubmit)
      setModal1Open(true);
    else returnSelected(dayjs(e).format("YYYY"));
  };

  return (

    <>

      <style jsx="true">{`
      .fyyeaR .ant-picker-input > input::placeholder {
        color:${colorPrimary}; 
      }
    `}</style>
      <DatePicker
        className="fyyeaR"
        placeholder="+ Add Fy"
        picker={"year"}
        suffixIcon=""
        variant="borderless"
        value={""}
        ref={dateRef}
        type="primary"
        onChange={openModel}
        disabledDate={(c) => {
          if (
            years?.find(
              (f) => {
                return dayjs(f.end).year() === dayjs(c).year()
              }

            )
          ) {
            return true;
          }
          return false;
        }}
      />

      <Modal
        title="Are you sure ?"
        centered
        open={modal1Open}
        onOk={submit}
        onCancel={() => setModal1Open(false)}
      >
        <p>
          Are you sure you want to add
          <span style={{ fontWeight: "bold", margin: "8px" }}>
            {dayjs(selected).format("YYYY") - 1} - {" "}
            {dayjs(selected).format("YY")}
          </span>
          financial year ?
        </p>
      </Modal>
    </>
  );
}
